<script>
import { defineComponent } from 'vue'
import Datepicker from '../../common/datepicker.vue'
import { localizeDate, unlocalizeDate, dateUSToDateISO } from '../../../../utils/date'

export default defineComponent({
    name: 'screen-test-datepicker',
    components: { Datepicker },
    data() {
        return {
            validFrom: null,

            t_valid_from: Lang.langGet('Not before'),

            minDate: '',
            maxDate: '',
            testDate: '',

            disabledDate: '04/20/2024',
            /** @type {string} */
            testFormat: Laravel.activeDateformat
        }
    },
    computed: {
        localizedDate() {
            return localizeDate(this.testDate, this.testFormat)
        },
        /** @type {DateUS|null} */
        unlocalizedDate() {
            return unlocalizeDate(this.localizedDate, this.testFormat)
        },
        /** @type {DateISO|null} */
        isoDate() {
            return dateUSToDateISO(this.unlocalizedDate)
        }
    },
    watch: {
        testDate(val) {
            console.log('datepicker emitted date:', val)
        }
    }
})
</script>

<template>
    <div class="test-container-datepicker">
        <div class="resizable-container-datepicker elevation-8">

            <datepicker
                v-model="disabledDate"
                disabled
                label="Disabled" />
            <datepicker
                v-model="minDate"
                label="Min" />
            <datepicker
                v-model="maxDate"
                label="Max" />
            <datepicker
                v-model="testDate"
                :max="maxDate"
                :min="minDate"
                label="Test" />
            <!--:max="datepicker_limit(valid_to, true)"
                :disabled="readonly || datePrivilege === false"-->

            <v-text-field v-model="testDate"
                          label="DateUS"
                          outlined />

            <v-text-field v-model="testFormat"
                          label="Output Format"
                          outlined />

            Localized date:
            {{ localizedDate }}

            <br />
            UnLocalized date:
            {{ unlocalizedDate }}
            <br />

            ISO date:
            {{ isoDate }}
        </div>
    </div>
</template>

<style>
.test-container-datepicker {
    width: 100%;
    height: 100%;

    display: flex;
    align-items: center;
    justify-content: center;
}

.test-container-datepicker .resizable-container-datepicker {
    width: 340px;
    height: 530px;

    resize: both;
    overflow: auto;

    padding: 16px;

    border-radius: 8px;
    outline: #0a568c solid 2px;
}
</style>
